export const MuiTooltip = (palette) => ({
  styleOverrides: {
    arrow: {
      color: '#ffffff',
    },
    tooltip: {
      padding: '12px',
      fontSize: '12px',
      lineHeight: '16px',
      color: palette.custom.gray1,
      background: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.15)',
      '& h3, & p': {
        margin: 0,
      },
    },
  },
});
